/** For use with react-dnd */
export var DraggableType;
(function (DraggableType) {
    /** Expects an `id` field to be provided */
    DraggableType["MEDIA_MANAGER_GALLECTION"] = "mm-gallection";
    DraggableType["MEDIA_MANAGER_SLIDER_GALLECTION"] = "mm-slider-gallection";
    DraggableType["MEDIA_MANAGER_DEVIATION"] = "mm-deviation";
    /** Expects a `deviation` field to be provided */
    DraggableType["DEVIATION"] = "deviation";
    /** Expects an `id` field to be provided */
    DraggableType["BADGE"] = "badge";
})(DraggableType || (DraggableType = {}));
// TODO: Figure out a decent way to type DND payloads
//# sourceMappingURL=dnd.js.map